<template>
    <div>
        <section>
                <div v-if="loaded" class="content">
                    <router-link @click.native="setIsNoSuccessSection()" to="/" tag="div" style="cursor: pointer;" class="mt40 text-center" v-if="isNoSuccessSection">
                        <img src="@/assets/img/logo-team.svg" alt="">
                    </router-link>
                    <div class="mt40 text-center" v-else>
                        <img src="@/assets/img/logo-team.svg" alt="">
                    </div>

                    <section class="container mt40">
                        <div class="auth-form-container">
							<div class="auth-form" v-if="step==1">
                                <div class="auth-form__wrap full">
									<div class="text-center">
						                <svg class="big-icon" style="width: 47px; height: 48px; ">
						                    <use xlink:href="@/assets/img/big-icons-sprite.svg#lock2"></use>
						                </svg>
						            </div>

									<div class="text-size-xxl text-bold text-center mt32" style="line-height: 39px;">
										{{user.firstName}},<br>
										ваши следующие шаги
									</div>

                                    <div class="mt32" style="line-height: 16px; width: 374px; margin: 0 auto;">
										1. Скачать, распечатать, заполнить и подписать договор<br><br>
										2. Отсканировать в PDF<br><br>
										<div class="" style="padding-left: 16px">
											а) Все листы договора, кроме последнего<br><br>
                                            б) Последний лист с реквизитам<br><br>
                                            в) Первый разворот паспорта и страницу с пропиской<br><br>
                                            г) ИНН и СНИЛС<br><br>
										</div>
										3. Загрузить указанные выше документы<br><br>
                                    </div>
									<div class="df df--center mt32">
										<button @click="firstStepRun()" type="button" name="button" class="btn">Продолжить</button>
									</div>
                                </div>
                            </div>

                            <div class="auth-form" v-if="step==2">
                                <div class="auth-form__wrap full">
									<div class="text-center">
						                <svg class="big-icon" style="width: 47px; height: 48px; ">
						                    <use xlink:href="@/assets/img/big-icons-sprite.svg#lock2"></use>
						                </svg>
						            </div>

									<div class="text-size-xxl text-bold text-center mt32" style="line-height: 39px;">
										{{user.firstName}},<br>
										теперь скачайте договор
									</div>

                                    <div class="mt32" style="line-height: 16px; text-align: center;">
                                        Скачивание начнётся автоматически через несколько секунд.<br><br>
                                        Если этого не произошло, нажмите на эту <a @click.prevent="openDownload()" href="#">ссылку</a>. <br><br>
                                        Переходите к следующему шагу только после скачивания договора<br><br>
										<div class="df df--center">
											<div class="checkbox mt24">
	                                            <input @change="dowloadedCheckbox.error=false" v-model="dowloadedCheckbox.value" :class="{error: dowloadedCheckbox.error}" type="checkbox" name="dowloadedCheckbox" id="dowloadedCheckbox">
	                                            <label for="dowloadedCheckbox">Договор успешно скачан</label>
	                                        </div>
										</div>
                                    </div>
									<div class="df df--center mt32">
										<button @click="secondStepRun()" type="button" name="button" class="btn">Продолжить</button>
									</div>
                                </div>
                            </div>
                            <div class="auth-form" v-if="step==3">
                                <div class="auth-form__wrap full">
									<div class="text-center">
						                <svg class="big-icon" style="width: 47px; height: 48px; ">
						                    <use xlink:href="@/assets/img/big-icons-sprite.svg#lock2"></use>
						                </svg>
						            </div>

									<div class="text-size-xxl text-bold text-center mt32" style="line-height: 39px;  text-align: center;">
										{{user.firstName}},<br>
										теперь загрузите договор
									</div>

                                    <div class="mt32 text-center">
                                        Обратите внимание, все сканы договора должны иметь<br>
                                        книжную (вертикальную) ориентацию
                                    </div>
									<div class="form-wrapper mt24">
										<div class="df df--center">
											<button @click="openInput('fileInputContract')" type="button" name="button" class="btn btn--blue-no-border full" :class="{load:form.fileInputContract.loading, error:form.fileInputContract.error}">
	                                            <span class="i i-upload mr8"></span>
	                                            <span class="file-name">{{form.fileInputContract.text?form.fileInputContract.text:form.fileInputContract.textDefault}}</span>
	                                            <span v-if="form.fileInputContract.loaded" @click.stop="clearFile('fileInputContract')" class="i i-close2"></span>
	                                        </button>
	                                        <input accept="application/pdf" style="display: none;" ref="fileInputContract" @change="onFileChange($event, 'fileInputContract')" type="file">
										</div>
	                                    <div class="df df--center mt24">
											<button @click="openInput('fileInputContractLast')" type="button" name="button" class="btn btn--blue-no-border full" :class="{load:form.fileInputContractLast.loading, error:form.fileInputContractLast.error }">
	                                            <span class="i i-upload mr8"></span>
	                                            <span class="file-name">{{form.fileInputContractLast.text?form.fileInputContractLast.text:form.fileInputContractLast.textDefault}}</span>
	                                            <span v-if="form.fileInputContractLast.loaded" @click.stop="clearFile('fileInputContractLast')" class="i i-close2"></span>
	                                        </button>
	                                        <input accept="application/pdf" style="display: none;" ref="fileInputContractLast" @change="onFileChange($event, 'fileInputContractLast')" type="file">
										</div>
									</div>
                                    <div class="df df--center mt32">
										<button @click="thirdStepRun()" type="button" name="button" class="btn">Продолжить</button>
									</div>
                                </div>
                            </div>
                            <div class="auth-form" v-if="step==4">
                                <div class="auth-form__wrap full">
									<div class="text-center">
						                <svg class="big-icon" style="width: 47px; height: 48px; ">
						                    <use xlink:href="@/assets/img/big-icons-sprite.svg#lock2"></use>
						                </svg>
						            </div>

									<div class="text-size-xxl text-bold text-center mt32" style="line-height: 39px;  text-align: center;">
										{{user.firstName}},<br>
										загрузите скан паспорта
									</div>

                                    <div class="mt32 text-center">
                                        Обратите внимание, на скане должны быть<br>
                                        первая страница паспорта и страница регистрации
                                    </div>
                                    <div class="form-wrapper df df--center mt24">
										<button @click="openInput('fileInputPass')" type="button" name="button" class="btn btn--blue-no-border full" :class="{load:form.fileInputPass.loading, error:form.fileInputPass.error}">
                                            <span class="i i-upload mr8"></span>
                                            <span class="file-name">{{form.fileInputPass.text?form.fileInputPass.text:form.fileInputPass.textDefault}}</span>
                                            <span v-if="form.fileInputPass.loaded" @click.stop="clearFile('fileInputContract')" class="i i-close2"></span>
                                        </button>
                                        <input accept="application/pdf" style="display: none;" ref="fileInputPass" @change="onFileChange($event, 'fileInputPass')" type="file">
									</div>
                                    <div class="df df--center mt32">
										<button @click="fifthStepRun()" type="button" name="button" class="btn">Продолжить</button>
									</div>
                                </div>
                            </div>
                            <div class="auth-form" v-if="step==5">
                                <div class="auth-form__wrap full">
									<div class="text-center">
						                <svg class="big-icon" style="width: 47px; height: 48px; ">
						                    <use xlink:href="@/assets/img/big-icons-sprite.svg#lock2"></use>
						                </svg>
						            </div>

									<div class="text-size-xxl text-bold text-center mt32" style="line-height: 39px;  text-align: center;">
										{{user.firstName}},<br>
                                        теперь укажите платёжные данные
									</div>

                                    <div class="text-center mt32">
                                        Заполняйте поля внимательно, потому что именно по этим реквизитам<br>
                                        мы будем перечислять вам вознаграждение
                                    </div>
									<div class="form-wrapper mt24">
										<div class="df df--center">
											<input-styled
								                    name="card"
								                    :placeholder="'Номер счета карты (20 цифр)'"
								                    :placeholderInput="'Номер счета карты (20 цифр)'"
								                    v-model="form.card.value"
													:maxLengthNum="20"
								                    @focus="form.card.error=false"
								                    :is-error="form.card.error">
								            </input-styled>
	                                    </div>
	                                    <div class="df df--center mt24">
											<input-styled
								                    name="bic"
								                    :placeholder="'БИК банка (9 цифр)'"
								                    :placeholderInput="'БИК банка (9 цифр)'"
													:maxLengthNum="9"
								                    v-model="form.bic.value"
								                    @focus="form.bic.error=false"
								                    :is-error="form.bic.error">
								            </input-styled>
	                                    </div>
	                                    <div class="df df--center mt24">
											<input-styled
								                    name="inn"
								                    :placeholder="'Ваш ИНН (12 цифр)'"
								                    :placeholderInput="'Ваш ИНН (12 цифр)'"
													:maxLengthNum="12"
								                    v-model="form.inn.value"
								                    @focus="form.inn.error=false"
								                    :is-error="form.inn.error">
								            </input-styled>
	                                    </div>
	                                    <div class="df df--center mt24">
											<input-styled
								                    name="snils"
								                    :placeholder="'Номер СНИЛС (11 цифр)'"
								                    :placeholderInput="'Номер СНИЛС (11 цифр)'"
													:maxLengthNum="11"
								                    v-model="form.snils.value"
								                    @focus="form.snils.error=false"
								                    :is-error="form.snils.error">
								            </input-styled>
	                                    </div>
										<div class="df df--center mt24">
											<button @click="openInput('fileInputInn')" type="button" name="button" class="btn btn--blue-no-border full" :class="{load:form.fileInputInn.loading, error:form.fileInputInn.error}">
	                                            <span class="i i-upload mr8"></span>
	                                            <span class="file-name">{{form.fileInputInn.text?form.fileInputInn.text:form.fileInputInn.textDefault}}</span>
	                                            <span v-if="form.fileInputInn.loaded" @click.stop="clearFile('fileInputInn')" class="i i-close2"></span>
	                                        </button>
	                                        <input accept="application/pdf" style="display: none;" ref="fileInputInn" @change="onFileChange($event, 'fileInputInn')" type="file">
										</div>
	                                    <div class="df df--center mt24">
											<button @click="openInput('fileInputSnils')" type="button" name="button" class="btn btn--blue-no-border full" :class="{load:form.fileInputSnils.loading, error:form.fileInputSnils.error}">
	                                            <span class="i i-upload mr8"></span>
	                                            <span class="file-name">{{form.fileInputSnils.text?form.fileInputSnils.text:form.fileInputSnils.textDefault}}</span>
	                                            <span v-if="form.fileInputSnils.loaded" @click.stop="clearFile('fileInputSnils')" class="i i-close2"></span>
	                                        </button>
	                                        <input accept="application/pdf" style="display: none;" ref="fileInputSnils" @change="onFileChange($event, 'fileInputSnils')" type="file">
										</div>
									</div>
                                    <div class="df df--center mt32">
										<button @click="sixthStepRun()" type="button" name="button" class="btn"><span class="i i-send mr4"></span>Отправить на проверку</button>
									</div>
                                </div>
                            </div>
                            <div class="auth-form" v-if="step==6">
                                <div class="auth-form__wrap full">
									<div class="text-center">
						                <svg class="big-icon" style="width: 47px; height: 48px; ">
						                    <use xlink:href="@/assets/img/big-icons-sprite.svg#lock2"></use>
						                </svg>
						            </div>
									<div class="text-size-xxl text-bold text-center mt32" style="line-height: 39px;">
										{{user.firstName}},<br>
										документы успешно загружены
									</div>
                                    <div class="mt32 text-center text-size-16" style="line-height: 24px;">
										В ближайшее время мы их проверим,<br>
										подпишем договор и вернём обратно ваш экземпляр<br>
										Как только всё будет готово, мы уведомим вас по СМС и E-mail.<br><br>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
				<vue-footer v-if="!isNoSuccessSection" :class="{'footer--center': !(isModerator)}" :show-logo="isModerator" :hide-offer="true"></vue-footer>
            </section>
    </div>
</template>
<script>
    import {mapState} from 'vuex';
    import VueFooter from '@/components/VueFooter.vue';
	import InputStyled from '@/components/forms/InputStyled.vue';
    export default {
        components: {
            VueFooter,
			InputStyled,
        },
        data() {
            return {
                loaded: false,
                step:1,
                appPath: process.env.VUE_APP_PATH_BACK,
                dowloadedCheckbox: {
                    value: false,
                    error: false,
                },
                form: {
                    fileInputContract: {
                        value: '',
                        textDefault: 'Загрузить все листы договора, кроме последнего',
                        text: '',
                        error: false,
                        loading: false,
                        loaded: false,
                    },
                    fileInputContractLast: {
                        value: '',
                        textDefault: 'Загрузить последний лист договора с реквизитами',
                        text: '',
                        error: false,
                        loading: false,
                        loaded: false,
                    },
                    fileInputPass: {
                        value: '',
                        textDefault: 'Загрузить скан паспорта, включая страницу с регистрацией',
                        text: '',
                        error: false,
                        loading: false,
                        loaded: false,
                    },
                    fileInputSnils: {
                        value: '',
                        textDefault: 'Загрузить скан СНИЛС',
                        text: '',
                        error: false,
                        loading: false,
                        loaded: false,
                    },
                    fileInputInn: {
                        value: '',
                        textDefault: 'Загрузить скан ИНН',
                        text: '',
                        error: false,
                        loading: false,
                        loaded: false,
                    },
                    card:{
                        value: '',
                        error: false,
                        validate: 20,
                    },
                    bic:{
                        value: '',
                        error: false,
                        validate: 9,
                    },
                    inn:{
                        value: '',
                        error: false,
                        validate: 12,
                    },
                    snils:{
                        value: '',
                        error: false,
                        validate: 11,
                    },
                }
            }
        },
        mounted() {
            this.$store.dispatch('usercontract/getContractData').then(() => {
                this.step = this.userData.step;
                this.loaded = true;
            });
        },
        methods: {
            openDownload(){
                window.open(this.downloadLink);
            },
            clearFile(input){
                this.form[input].text = '';
                this.form[input].value = '';
                this.form[input].loading = false;
                this.form[input].loaded = false;
                this.$refs[input].value = null;
                return false;
            },
            firstStepRun(){
                this.step++;
                window.open(this.downloadLink);
            },
            secondStepRun(){
                let error = false;
                if(this.dowloadedCheckbox.value == ''){
                    error = true;
                    this.dowloadedCheckbox.error = true;
                }

                if(!error){
                    this.step++;
                }
            },
            thirdStepRun(){
                let error = false;
                if(this.form['fileInputContract'].value == ''){
                    this.form['fileInputContract'].error = true;
                    error = true;
                }
                if(this.form['fileInputContractLast'].value == ''){
                    this.form['fileInputContractLast'].error = true;
                    error = true;
                }
                if(!error){
                    this.$store.dispatch('usercontract/runStep',{'setStep':'paymentData'}).then(() => {
                        this.step++;
                    });
                }
            },
            fifthStepRun(){
                let error = false;
                if(this.form['fileInputPass'].value == ''){
                    this.form['fileInputPass'].error = true;
                    error = true;
                }
                if(!error){
                    this.$store.dispatch('usercontract/runStep',{'setStep':'pasport'}).then(() => {
                        this.step++;
                    });
                }
            },
            sixthStepRun(){
                let error = false;
                let fields = ['card','bic','inn','snils'], fieldsSend = [];

                fields.forEach(element=>{
                    if(this.form[element].value == '' || this.form[element].value.length != this.form[element].validate){
                        this.form[element].error = true;
                        error = true;
                    }
                    else{
                        fieldsSend[element] = this.form[element].value;
                    }
                });
                if(this.form['fileInputInn'].value == ''){
                    this.form['fileInputInn'].error = true;
                    error = true;
                }
                if(this.form['fileInputSnils'].value == ''){
                    this.form['fileInputSnils'].error = true;
                    error = true;
                }
                if(!error){
                    fieldsSend['operation'] = 'final';
                    this.$store.dispatch('usercontract/runStep',fieldsSend).then(() => {
                        this.step++;
                    });
                }
            },
            runUpload(){
                let error = false, fields = [];
                for (let field in this.form) {
                    fields[field] = this.form[field].value;
                }
                if(!error){
                    this.$store.dispatch('usercontract/upload',fields).then(() => {
                        this.step++;
                    });

                }
            },
            openInput(item){
                this.$refs[item].click();
            },
            onFileChange(e, item){
                let fields = [];
                let files = e.target.files || e.dataTransfer.files;
                this.form[item].value = files[0];
                this.form[item].loading = true;
                this.form[item].error = false;

                fields[item] = files[0];
                fields['operation'] = 'uploadFile';
                this.$store.dispatch('usercontract/runStep',fields).then(() => {
                    this.form[item].loading = false;
                    this.form[item].loaded = true;
                    this.form[item].text = files[0].name;
                });
            }
        },
        computed: {
            ...mapState({
                user: state => state.users.user,
                isNoSuccessSection: state => state.auth.isNoSuccessSection,
                sample: state => state.usercontract.sample,
                userData: state => state.usercontract.userData,
            }),
            downloadLink(){
                return this.appPath+'/public/download_contract.php?uid='+this.$route.params.uid;
            },
            isModerator() {
                if (this.user.access_rights) {
                    return this.user.access_rights.is_moderator;
                }
                else {
                    return false;
                }
            },
        },
    }
</script>
